import clsx from 'clsx';
import { PropsWithChildren } from 'react';

import './IntakePageTextBox.scss';

type Props = PropsWithChildren & {
  variant?: 'cream';
  align?: 'center';
};

export const IntakePageTextBox: React.FC<Props> = ({
  children,
  variant = 'default',
  align = 'default',
}) => (
  <div
    className={clsx(
      'IntakePageTextBox',
      `IntakePageTextBox--colored-as-${variant}`,
      `IntakePageTextBox--align-${align}`
    )}
  >
    {children}
  </div>
);
